export enum CommentType {
  post = 'post_comment',
  reply = 'reply_comment',
}
